import { type ReactElement } from "react";

import clsx from "clsx";

interface Props {
  label: string;
  icon?: ReactElement | null;
  hasChevron?: boolean;
  onClick?: () => void;
  className?: string;
  isSelected?: boolean;
  isDisabled?: boolean;
}

export const MenuSubmenuItem = ({
  label,
  icon,
  hasChevron = false,
  isSelected = false,
  isDisabled = false,
  onClick,
  className,
}: Props) => (
  <div
    className={clsx(
      "px-4 py-1.5 flex items-center justify-between",
      {
        "font-semibold bg-cosmic-3": isSelected,
        "text-gray pointer-events-none": isDisabled,
        "hover:cursor-pointer hover:bg-cosmic-4 hover:font-semibold":
          !isDisabled,
      },
      className,
    )}
    onClick={onClick}
  >
    <div>
      <span
        className={clsx({
          "text-gray": isDisabled,
          "text-cosmic": !isDisabled,
        })}
      >
        {icon}
      </span>
      <span
        className={clsx("text-sm leading-loose", {
          "ml-2": icon,
          "text-gray": isDisabled,
          "text-interstellar": !isDisabled,
        })}
      >
        {label}
      </span>
    </div>
    {hasChevron && (
      <i
        className={clsx(
          {
            "text-gray": isDisabled,
            "text-cosmic": !isDisabled,
          },
          "fa-regular fa-sharp fa-chevron-right text-cosmic text-xs",
        )}
      />
    )}
  </div>
);
